module.exports = __webpack_public_path__ + "img/av080.0cfd9eb5.png";